// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class CustomButtonsGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.CUSTOM_BUTTONS_GROUP, null, pfixFieldSet);
    }
    getTitle() {
        return this.GetValue(FieldsFactory.FIELD_TITLE);
    }
    getTooltip() {
        return this.GetValue(FieldsFactory.FIELD_TOOLTIP);
    }
    getURL() {
        return this.GetValue(FieldsFactory.FIELD_URL);
    }
    getCustomButtonNumber() {
        return this.GetValue(FieldsFactory.FIELD_NUMBER);
    }
}
